import {
  Paper,
  Stack,
  Group,
  SimpleGrid,
  Skeleton,
  Divider,
} from '@mantine/core';
import { useApp } from '../../../../context/AppContext';

export const ProfilePageSkeletonLoader = ({
  isTabletOrBelow,
}: {
  isTabletOrBelow: boolean;
}) => {
  const { scrollAreaHeight } = useApp();

  return (
    <Paper shadow="xl" radius="md" h={scrollAreaHeight} w="100%">
      <Stack bg="white" p="lg" align="start" w="100%">
        {/* Profile Header */}
        {isTabletOrBelow ? (
          <Stack justify="center" align="center" w="100%" gap={2}>
            <Skeleton height={125} width={125} radius="50%" />
            <Skeleton height={24} width={200} />
            <Skeleton height={16} width={150} />
            <Group>
              <Skeleton height={16} width={16} radius="50%" />
              <Skeleton height={16} width={100} />
              <Skeleton height={16} width={16} radius="50%" />
              <Skeleton height={16} width={120} />
            </Group>
          </Stack>
        ) : (
          <Group align="start" wrap="wrap">
            <Skeleton height={125} width={125} radius="50%" />
            <Stack gap={5} style={{ flex: 1 }}>
              <Skeleton height={24} width={200} />
              <Skeleton height={16} width={150} />
              <Group>
                <Skeleton height={16} width={16} radius="50%" />
                <Skeleton height={16} width={100} />
                <Skeleton height={16} width={16} radius="50%" />
                <Skeleton height={16} width={120} />
              </Group>
            </Stack>
          </Group>
        )}
        <Divider w="100%" />

        {/* Action Buttons */}
        <Group gap="xs">
          <Skeleton height={36} width={140} radius="md" />
          <Skeleton height={36} width={120} radius="md" />
          <Skeleton height={36} width={120} radius="md" />
          <Skeleton height={36} width={120} radius="md" />
        </Group>

        {/* Bio Section */}
        <Skeleton height={24} width={80} />
        <Skeleton height={16} width="100%" />
        <Skeleton height={16} width="95%" />
        <Skeleton height={16} width="98%" />

        {/* About Section */}
        <Skeleton height={24} width={80} />
        <Skeleton height={16} width="100%" />
        <Skeleton height={16} width="95%" />
        <Skeleton height={16} width="98%" />

        {/* Socials Section */}
        <Skeleton height={24} width={80} />
        <Group>
          <Skeleton height={35} width={35} radius="md" />
          <Skeleton height={35} width={35} radius="md" />
          <Skeleton height={35} width={35} radius="md" />
          <Skeleton height={35} width={35} radius="md" />
        </Group>

        {/* Additional Info */}
        <SimpleGrid
          cols={{ base: 1, sm: 2, lg: 3 }}
          spacing="lg"
          mt="md"
          w="100%"
        >
          <div>
            <Skeleton height={24} width={100} mb={8} />
            <Skeleton height={16} width={180} />
          </div>
          <div>
            <Skeleton height={24} width={100} mb={8} />
            <Skeleton height={16} width={220} />
          </div>
          <div>
            <Skeleton height={24} width={120} mb={8} />
            <Skeleton height={16} width={250} />
          </div>
        </SimpleGrid>
      </Stack>
    </Paper>
  );
};
